import { render, staticRenderFns } from "./TickChart.vue?vue&type=template&id=46968d44&"
import script from "./TickChart.vue?vue&type=script&lang=js&"
export * from "./TickChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports